module.exports = __webpack_public_path__ + "img/menus-blue.af704823.svg";